<script setup>
import { ref, onMounted } from "vue";
import { setMeta } from "@/utils/util";

onMounted(() => {
  document.title = "Terms of Service";
  setMeta("description", "DevOnlineTools Terms of Service - User rights and responsibilities");
  setMeta("keywords", "terms of service,user agreement,terms and conditions,DevOnlineTools terms");
});
</script>

<template>
  <div class="tool-body">
    <h1>Terms of Service</h1>
    <div class="content">
      <h2>English Version</h2>
      <p>Last updated: {{ new Date().toISOString().split('T')[0] }}</p>
      
      <h3>1. Acceptance of Terms</h3>
      <p>By accessing and using DevOnlineTools, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>

      <h3>2. Use of Services</h3>
      <p>Our services are provided for development and testing purposes. You agree to:</p>
      <ul>
        <li>Use the services in compliance with all applicable laws</li>
        <li>Not misuse or attempt to harm our services</li>
        <li>Not use our services for any illegal purposes</li>
        <li>Not upload malicious code or content</li>
      </ul>

      <h3>3. Service Limitations</h3>
      <p>We provide our services on an "as is" and "as available" basis. We may:</p>
      <ul>
        <li>Modify or discontinue any feature at any time</li>
        <li>Impose limits on certain features or services</li>
        <li>Restrict access to parts of or all of the services</li>
      </ul>

      <h3>4. Intellectual Property</h3>
      <p>All content and services remain the property of DevOnlineTools. Users retain ownership of their data.</p>

      <h3>5. Disclaimer of Warranties</h3>
      <p>We do not guarantee that our services will be uninterrupted or error-free. We are not responsible for any data loss or damage.</p>

      <h2>中文版本</h2>
      <p>最后更新日期：{{ new Date().toISOString().split('T')[0] }}</p>

      <h3>1. 条款接受</h3>
      <p>访问和使用DevOnlineTools即表示您同意受这些服务条款的约束。如果您不同意这些条款，请不要使用我们的服务。</p>

      <h3>2. 服务使用</h3>
      <p>我们的服务仅供开发和测试使用。您同意：</p>
      <ul>
        <li>遵守所有适用法律使用服务</li>
        <li>不滥用或试图损害我们的服务</li>
        <li>不将我们的服务用于任何非法目的</li>
        <li>不上传恶意代码或内容</li>
      </ul>

      <h3>3. 服务限制</h3>
      <p>我们按"现状"和"可用性"提供服务。我们可能：</p>
      <ul>
        <li>随时修改或终止任何功能</li>
        <li>对某些功能或服务施加限制</li>
        <li>限制对部分或全部服务的访问</li>
      </ul>

      <h3>4. 知识产权</h3>
      <p>所有内容和服务均为DevOnlineTools的财产。用户保留其数据的所有权。</p>

      <h3>5. 免责声明</h3>
      <p>我们不保证我们的服务不会中断或无错误。我们对任何数据丢失或损坏不承担责任。</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.6;

  h2 {
    margin-top: 40px;
    margin-bottom: 20px;
    color: var(--el-color-primary);
  }

  h3 {
    margin-top: 30px;
    margin-bottom: 15px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 15px;
  }
}
</style>